export const ROUTES = {
  login: '/login',
  courses: '/courses',
  mission: '/missions',
  courseReportList: '/course-reports',
  missionReportList: '/mission-reports',
  courseReportDetail: '/course-report/:id',
  missionReportDetail: '/mission-report/:id',
  userList: '/user-list',
  main: '/main',
  courseDetail: '/course-detail',
};

export const API_URL = (url: string) => (process.env.REACT_APP_API_URL ?? '') + url;
export const S3_URL = (url: string) => (process.env.REACT_APP_S3_URL ?? '') + url;

export const ROLES = {
  platformAdmin: 'platform-admin',
  departmentAdmin: 'department-admin',
  trainee: 'trainee',
};
